import { isGuest } from '~/services/guestManagement'
import { type RouteName, guestRoutes } from '~/services/routing'

export default defineNuxtRouteMiddleware((to, from) => {
  // guest mode can only access guest routes!
  if (isGuest.value && !guestRoutes.includes(to.name as RouteName)) {
    return navigateTo({ name: guestRoutes[0]! })
  }
})
